import * as React from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

export default function Selector({items, selection, setSelection}) {

  const handleChange = (event) => {
    setSelection(event.target.value);
  };

  return (
    <Box sx={{ maxWidth: 220 }}>
      <FormControl fullWidth>
        <InputLabel id="demo-simple-select-label">Filtro</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={selection}
          label="Filtro"
          onChange={handleChange}
        >
            {
                items?.map((item, index) => {
                    return <MenuItem key={index} value={item}>{item}</MenuItem>
                })
            }
        </Select>
      </FormControl>
    </Box>
  );
}